import React from 'react';
import ChemComponent from './ChemComponent';
import Form from 'react-bootstrap/Form';

class ADACheckbox extends ChemComponent {
	constructor(props) {
		super(props);
		
		this.cbRef = React.createRef();
	}	

	componentDidMount() {
		this.addBorder();
	}
	
	componentDidUpdate(prevProps) {
		this.addBorder();
	}
	
	addBorder()
	{
		if (this.cbRef.current && this.cbRef.current.attributes) {
			// none of this stuff works
			//const namedNodeMap = this.cbRef.current.attributes;

			// Create a new attribute node
			//const newAttribute = document.createAttribute('style');
			//newAttribute.value = 'accent-color: black;';

			// Add the new attribute to the NamedNodeMap
			//namedNodeMap.setNamedItem(newAttribute);
			
			//this.cbRef.current.attributes['accent-color'] = 'black';
			/*
			var keys = Object.keys(this.cbRef.current);
			for (var i = 0; i < keys.length; i++) {
				console.log(keys[i]);
			}
			*/
			//console.dir(this.cbRef.current); //.input['accent-color'] = '#ccc';
			/*
			if (this.isEmpty(this.props.autoComplete)) {
				this.dpRef.current.input.autocomplete = 'off';
			} else {
				this.dpRef.current.input.autocomplete = this.props.autoComplete;
			}
			if (!this.isEmpty(this.props.ariaLabelledBy)) {
				this.dpRef.current.input['aria-labelledby'] = this.props.ariaLabelledBy;
			}
			*/
		}
	}

	render() {
		return (
			<Form.Check ref={this.cbRef} {...this.props} />
		);
	}
}

export default ADACheckbox;
